import { Redirect, Route, Switch, withRouter, RouteComponentProps } from 'react-router-dom';
import Login from './Login';
import SecretLogin from './SecretLogin';
import Choose from './Choose';
import Logout from './Logout';
import Registration from './Registration';
import ForgetPassword from './ForgetPassword';
import PasswordReset from './PasswordReset';

const AuthBasicRoutes = ({ match: { url } }: RouteComponentProps) => (
  <Switch>
    <Route path={`${url}/choose`} exact component={Choose} />
    <Route path={`${url}/login`} exact component={Login} />
    <Route path={`${url}/otherLogin`} exact component={SecretLogin} />
    <Route path={`${url}/logout`} exact component={Logout} />
    <Route path={`${url}/register`} exact component={Registration} />
    <Route path={`${url}/forget-password`} exact component={ForgetPassword} />
    <Route path={`${url}/password-reset`} exact component={PasswordReset} />

    <Redirect to="/errors/404" />
  </Switch>
);

export default withRouter(AuthBasicRoutes);
